import { loginSuccess, resetAuth } from './auth.actions';
import { Action } from 'redux';
import { REHYDRATE } from 'redux-persist/constants';
import * as Immutable from 'seamless-immutable';
import { ImmutableObject } from 'seamless-immutable';
import { isType } from 'typescript-fsa';
import { AppState } from '../reducers';
import { getActiveStoryId } from '../StoryEdit/story-edit.reducer';
import { getAwsUrl } from '../../utils/url';
import { getApiRoot } from '../api';
import { replaceWhitespaces } from '../../utils/string';

export interface User {
  username: string;
  token?: string;
  isLoggedIn: boolean;
  isRehydrated: boolean;
}

type UserState = User & ImmutableObject<User>;

const initialState = Immutable.from<User>({
  isLoggedIn: false,
  token: void 0,
  username: 'unknown',
  isRehydrated: false,
});

export default function reduce(
  state: UserState = initialState,
  action: Action
) {
  if (isType(action, loginSuccess)) {
    return state.merge(action.payload);
  }

  if (action.type === REHYDRATE) {
    const payload = (action as any).payload;
    const user: User = payload.auth ? payload.auth : ({} as User);
    user.isRehydrated = true;
    return state.merge(user);
  }

  if (isType(action, resetAuth)) {
    return initialState;
  }

  return state;
}

export function isAuthRehydrated(state: AppState) {
  return state.auth.isRehydrated;
}

export function getAuthState(state: AppState) {
  return state.auth;
}

export function getToken(state: AppState) {
  const auth = getAuthState(state);
  return auth.token;
}

export interface S3UploadOptions {
  server: string;
  signingUrl: string;
  signingUrlMethod: 'string';
  signingUrlHeaders: Headers;
  s3Url: string;
  uploadRequestHeaders: {};
}

export function getS3UploadOptions(state: AppState): S3UploadOptions | object {
  const token = getToken(state);
  const storyId = getActiveStoryId(state) || 'misc';
  if (!token) {
    return {};
  }

  return {
    s3Url: getAwsUrl(),
    uploadRequestHeaders: {},
    getSignedUrl: (file: any, callback: (params: object) => void): void => {
      const fileName = replaceWhitespaces(file.name);

      fetch(
        `${getApiRoot()}` +
          `/api/s3/signed-upload-url?objectName=${fileName}&contentType=${
            file.type
          }&storyId=${storyId}`,
        {
          method: 'GET',
          headers: new Headers({ Authorization: `Bearer ${token}` }),
        }
      )
        .then(response => response.json())
        .then(responseData => callback(responseData));
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/Auth/auth.reducer.ts